import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const [user, setUser] = useState({
        name: localStorage.getItem('name') || '',
        userId: localStorage.getItem('userId') || ''
    });

    useEffect(() => {
        setUser({
            name: localStorage.getItem('name') || '',
            userId: localStorage.getItem('userId') || ''
        });
    }, []);

    return (
        <UserContext.Provider value={{ user, setUser }}>
            {children}
        </UserContext.Provider>
    );
};
